import { authService } from "../services/Services";
import { TrackedObject } from "../types/TrackedObject";
import { useApiQuery } from "./useApiQuery";
import { createUrlWithQuery } from "./utils";

export interface UseFetchTrackedObjectsParams {
    latestOnly?: boolean;
    directionIds?: number[];
}

export const useFetchTrackedObjects = (
    videoId: string | null | undefined,
    params: UseFetchTrackedObjectsParams,
) => {
    const token = authService.getIdentityToken();

    const endpoint = `/videos/${videoId}/objects`;

    const { data = [], ...queryResult } = useApiQuery<TrackedObject[]>({
        queryKey: ["objects", videoId],
        endpoint: createUrlWithQuery(
            endpoint,
            {
                latestOnly: params.latestOnly,
                directionId: params.directionIds,
            },
            {
                arrayFormat: "repeat",
            },
        ),
        enabled: !!token && !!videoId,
    });
    return { data, ...queryResult };
};
